import { CircularProgress } from '@mui/material';
import styled from '@emotion/styled';

type TableLoaderProps = {
  columns: number;
};

export const TableLoader = ({ columns }: TableLoaderProps) => {
  return (
    <TBody>
      <tr>
        <td colSpan={columns}>
          <div>
            <CircularProgress />
          </div>
        </td>
      </tr>
    </TBody>
  );
};

const TBody = styled.tbody`
  position: absolute;
  top: 62px;
  left: 0;
  right: 0;
  z-index: 3;
  bottom: 0;
  tr {
    width: 100%;
    height: 100%;
    td {
      width: 100%;
      div {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 240px;
        padding-bottom: 240px;
      }
    }
  }
`;
